import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { AgeRange } from '../models/AgeRange';

@Injectable({ providedIn: 'root' })

export class AgeRangeService { 
  private _ENDPOINT: string = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/ageranges';   
  }
 
  getAll(): Observable<Array<AgeRange>> { 
    return this.http.get<Array<AgeRange>>(this._ENDPOINT + '');
  }
  
  getById(id: any): Observable<AgeRange> {
    const url = this._ENDPOINT+'/'+id;
    return this.http.get<AgeRange>(url);
  }

  /** POST: add a new ageRange to the server */
  add(ageRange: AgeRange): Observable<AgeRange> {
    return this.http.post<AgeRange>(this._ENDPOINT, ageRange, this.httpOptions).pipe(
      tap((newAgeRange: AgeRange) => this.log('added ageRange w/ id=${newAgeRange.id}')),
      catchError(this.handleError<AgeRange>('add'))
    );
  }

  /** DELETE: delete the ageRange from the server */
  delete(id: number): Observable<AgeRange> {
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<AgeRange>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted ageRange id=${id}')),
      catchError(this.handleError<AgeRange>('delete'))
    );
  }

  /** PUT: update the ageRange on the server */
  update(id: number, ageRange: AgeRange): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id, ageRange , this.httpOptions).pipe(
      tap(_ => this.log('updated ageRange id=${ageRange.Id}')),
      catchError(this.handleError<any>('update'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a AgeRangeService message with the MessageService */
  private log(message: string) {
    this.messageService.add('AgeRangeService: ${message}');
  }
}
